<template>
    <div class="xcard">
        <!-- <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn> -->
        <h3 class="text-primary text-center ma-0">
            Motivos de descuentos
        </h3>

        <div class="table-responsive">
            <v-row dense>
                <v-col cols="3">
                    <v-combobox v-model="descuentostipo" :loading="loadingd" :items="descuentostipos" :value="'nombre'" label="Tipo descuento" hide-details outlined dense></v-combobox>
                </v-col>
                <v-col cols="3">
                    <v-text-field label="Buscar" :disabled="motivos.length == 0" placeholder="Buscar en la tabla..." hide-details v-model="buscar" outlined dense></v-text-field>
                </v-col>
                <v-col cols="3" class="offset-3">
                    <v-btn class="ma-0 float-right" dense outlined color="green" @click="crearmotivo()"> 
                        <v-icon small left>mdi-book-arrow-up</v-icon> Crear Motivo </v-btn>
                </v-col>
            </v-row>

            <table class="table table-hover" id="midatatable">
                <thead style="background:#196391;">
                    <tr class="white--text">
                        <th>Nro</th>
                        <th>Descripcion</th>
                        <th>Fecha registro</th>
                        <th>Tipo</th>
                        <th>ID Negocio</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-bind:key="ind" v-for="(m, ind) in motivos">
                        <td>{{ ind + 1 }}</td>
                        <td>{{ m.descripcion }}</td>
                        <td>{{ parsefecha(m.fecha_registro) }}</td>
                        <td>{{ m.descuento_tipo }}</td>
                        <td>{{ m.unidad_negocio_id }}</td>
                    </tr>
                </tbody>
            </table>

            <p class="text-center text-danger">
                <b>{{ msg }}</b>
            </p>
            <div class="text-center">
                <div style="display: inline-block;" v-show="loading" class="loader"></div>
            </div>
        </div>

        <div>
            <MotivoCreate ref="motivocreate" />
        </div>
    </div>
</template>

<script>
import MotivoCreate from "@/components/AMotivo-create.vue";
import axios from "axios";
export default {
    data() {
        return {
            descuentostipos: [],
            descuentostipo:{value:'',text:''},
            loadingd: false,
            loading: false,
            unidad_negocio: -1,
            msg: "",
            motivos: [],
            buscar: "",
        };
    },
    components: { MotivoCreate },
    watch: {
        buscar: function() {
            this.myFunction1(this.buscar.trim());
        },
        "$store.state.CARGO": function() {
            try {
                this.unidad_negocio = this.$store.state.CARGO.sede.unidad_negocio;
                this.listarmotivos();
            } catch (e) {
                window.console.error(e);
            }
        },
        'descuentostipo.value': function(){
            this.listarmotivos();
        }
    },
    methods: {
        crearmotivo() {
            this.$refs.motivocreate.open();
        },
        parsefecha(f) {
            if (!f) return "-";
            let fs = f.split(" ");
            let fs1 = fs[0].split("-");
            let fs2 = fs[1].split(":");
            return `${fs1[2]}/${fs1[1]}/${fs1[0]} ${fs2[0]}:${fs2[1]}`;
        },
        listarmotivos() {
            const vue = this;
            let url = `${process.env.VUE_APP_API_REST}/api/v1/motivos?unidad_negocio_id=${this.unidad_negocio}`;
            if( this.descuentostipo.id > 0 ) url += `&descuento_tipo_id=${this.descuentostipo.id}`;
            window.console.log( url );
            this.motivos = [];
            vue.loading = true;
            axios
                .get(url)
                .then((res) => {
                    window.console.log(res);
                    if (res.data == "") res.data = { data: [] };
                    vue.motivos = res.data.data;
                    vue.loading = false;
                })
                .catch((error) => {
                    window.console.error(error);
                    vue.loading = false;
                });
        },
        getdescuentostipos(){
            const vue = this;
            const url = `${process.env.VUE_APP_API_REST}/api/v1/descuento-tipos`;
            this.loadingd = true;
            axios.get(url).then((res) => {
                res.data.data.forEach( x => {
                    x.text = x.nombre;
                    x.value = x.id;
                    vue.descuentostipos.push( x );
                });
                let todos = {text:'Todos', id:-1};
                vue.descuentostipos.push( todos );
                vue.descuentostipo = todos;
                vue.loadingd = false;
            })
            .catch((error) => {
                window.console.log(error);
                vue.loadingd = false;
            });
        },
        myFunction1(filtro) {
            filtro = filtro.toUpperCase();
            var table, tr, tdd, td, i, j, txtValue;
            table = document.getElementById("midatatable");
            tr = table.getElementsByTagName("tr");

            for (i = 0; i < tr.length; i++) {
                tdd = tr[i].getElementsByTagName("td");
                for (j = 1; j < tdd.length; j++) {
                    td = tdd[j];
                    if (td) {
                        txtValue = td.textContent;
                        if (txtValue.toUpperCase().indexOf(filtro) > -1) {
                            tr[i].style.display = "";
                            break;
                        } else {
                            tr[i].style.display = "none";
                        }
                    }
                }
            }
        },
    },
    mounted() {
        try {
            this.unidad_negocio = this.$store.state.CARGO.sede.unidad_negocio;
            this.listarmotivos();
            this.getdescuentostipos();
        } catch (e) {
            window.console.error(e);
        }
    },
};
</script>
